export var ContentType;
(function (ContentType) {
    ContentType["HEADER"] = "header";
    ContentType["BANNER"] = "banner";
    ContentType["FOOTER"] = "footer";
    ContentType["LEFT"] = "left";
    ContentType["INLINE"] = "inline";
})(ContentType || (ContentType = {}));
export class SearchMerchandisingStore {
    constructor(services, merchData) {
        this.redirect = '';
        this.content = {};
        this.campaigns = [];
        if (merchData) {
            this.redirect = merchData.redirect || '';
            if (merchData.content) {
                Object.values(ContentType).forEach((type) => {
                    if (merchData.content && merchData.content[type]) {
                        this.content[type] = new Content(merchData.content[type]);
                    }
                });
            }
            if (merchData.campaigns) {
                this.campaigns = merchData.campaigns;
                // if we find a 'landing-page', get landingPage details from merchandising.campaigns
                merchData.campaigns.forEach((campaign) => {
                    if (campaign.type == 'landing-page') {
                        this.landingPage = campaign;
                    }
                });
            }
            if (merchData.personalized)
                this.personalized = merchData.personalized;
        }
    }
}
class Content extends Array {
    static get [Symbol.species]() {
        return Array;
    }
    constructor(content) {
        super(...content);
    }
}
